export const getSubRoute = () => {
	const pathnameParts = window.location.pathname.split("/").filter(Boolean);

	// Return only the last part of the path (e.g., "asit-gallery")
	if (pathnameParts.length > 0) {
		return pathnameParts[pathnameParts.length - 1];
	}

	const storedPath = localStorage.getItem("path");
	if (storedPath) {
		return storedPath;
	}

	return "";
};
